
















import Vue from 'vue';
import { forEach } from 'lodash';

// TODO TEMP until we figure out how to go about this
// eslint-disable-next-line no-restricted-imports
import initLibs from 'legacy/_general/init_libs';

import { loadNewObjectPage, createNewObject } from '@/utils/crudActions';
import { redirect } from '@/utils';
import { Alert, AlertType } from '@/components/global_alerts/types';

import { CreateNewObjectResponse } from './types';

enum AfterSaveAction {
  Close,
  AddAnother,
  LinkJira,
}

export default Vue.extend({
  name: 'NewObject',
  props: {
    url: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      htmlContent: '',
      isSending: false,
    };
  },
  computed: {
    insideSPA(): boolean {
      return !!this.$router;
    },
  },
  async mounted() {
    await this.fetchPage();
    this.hijackButtons();
  },
  methods: {
    async fetchPage() {
      const html = await this.loadNewObjectPage(this.url);
      const div = document.createElement('div');
      div.innerHTML = html;
      this.htmlContent = div.querySelector('.new-object-page').innerHTML;
      await this.$nextTick();
      initLibs();
    },
    hijackButtons() {
      const submitButtons = this.$el.querySelectorAll('button[type=submit]');
      forEach(submitButtons, button => {
        button.addEventListener('click', (event: Event) => {
          event.preventDefault();
          const clickedButton = (event.currentTarget as HTMLButtonElement).name;
          const buttonActionMap = {
            btn_save_link_jira: AfterSaveAction.LinkJira,
            btn_save_add_another: AfterSaveAction.AddAnother,
            btn_save: AfterSaveAction.Close,
          };
          const action = buttonActionMap[clickedButton] as AfterSaveAction;

          this.postForm(action);
        });
      });

      const cancelLink = this.$el.querySelector('.controls-block .btn-link');
      cancelLink.addEventListener('click', event => {
        event.preventDefault();
        this.$emit('close');
      });
    },
    async postForm(action: AfterSaveAction) {
      if (this.isSending) return;
      const form = <HTMLFormElement>this.$el.querySelector('form');
      const formData = <{ name: string; value: string }[]>[];

      new FormData(form).forEach((value: string, name: string) => {
        formData.push({ name, value });
      });

      try {
        this.toggleSaveButtons(false);
        const data = (await this.createNewObject({
          url: '/sor/api/create_object/',
          data: {
            objectType: this.type,
            ignoreWarnings: form['ignore-warnings'].checked,
            formData: formData,
          },
          csrf: form.csrf_token.value,
        })) as CreateNewObjectResponse;
        this.handleSuccessfulSave(data, action);
      } catch (error) {
        this.toggleSaveButtons(true);
        this.showAlert(error);
      }
    },
    async handleSuccessfulSave(data: CreateNewObjectResponse, action: AfterSaveAction) {
      this.toggleSaveButtons(true);
      const msg = this.buildSuccessMessage(data);

      if (action === AfterSaveAction.Close) {
        this.closeModal(msg);
      } else if (action === AfterSaveAction.AddAnother) {
        await this.fetchPage();
        this.hijackButtons();
        this.showAlert(msg);

        // Wait for HTML to render
        this.$nextTick().then(() => {
          this.$el.querySelector('.modal-header').scrollIntoView({ behavior: 'smooth', block: 'end' });
        });
      } else {
        this.showAlert(msg, true);
        this.redirectToObjectInfo(data.objectUrl);
      }
    },
    buildSuccessMessage(data: CreateNewObjectResponse): Alert {
      const title = data.objectTitle.length ? data.objectTitle : data.objectType;
      return {
        type: AlertType.Success,
        message: `<a href="${data.objectUrl}">${title}</a> ` + 'has been created successfully.',
        stay: false,
      };
    },
    closeModal(msg: Alert) {
      if (this.insideSPA) {
        this.$store.dispatch('modals/confirm');
        this.showAlert(msg);
      } else {
        if (window.GGRC.zenModal.modals.length > 1) {
          this.showAlert({
            ...msg,
            stay: false,
          });
        } else {
          this.showAlert(msg, true);
        }
        this.$emit('close');
        window.GGRC.zenModal.$emit('reloadPage');
      }
    },
    redirectToObjectInfo(redirectUrl: string) {
      this.redirect(`${redirectUrl}?linkJira=true`);
    },
    showAlert(alert, nextLoad = false) {
      if (this.insideSPA) {
        this.$store.dispatch('alerts/show', alert);
      } else {
        if (nextLoad) {
          window.GGRC.NotifyNextLoad(alert);
        } else {
          window.GGRC.Notify(alert);
        }
      }
    },
    toggleSaveButtons(enabled) {
      this.isSending = !enabled;
      const submitButtons = this.$el.querySelectorAll('button[type=submit]');
      forEach(submitButtons, button => {
        if (enabled) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
      });
    },
    redirect,
    loadNewObjectPage,
    createNewObject,
  },
});
